import React from "react";
import { observer } from "mobx-react";
import { action } from "mobx";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";

import DeleteButton from "../common_components/DeleteButton";

@injectIntl
@observer
export default class TodosLoadPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { note, intl } = this.props;
    const { formatMessage } = intl;

    return (
      <div className="note-todos-load-container">
        {note.cardTodoLists.map((todoList, index) => {
          const title = todoList.name ? todoList.name : " ";
          const size =
            todoList.items.length > 0 ? ` (${todoList.items.length}) ` : "";

          // if its temporary list (no valid id from server), then ignore it
          if (!note._isPersisted(todoList)) {
            return null;
          }
          return (
            <div className="note-todos-load-item" key={index}>
              <span
                className="note-todos-load-item-name"
                onClick={() => this.loadTodoList(todoList)}
                style={{ marginBottom: "5px" }}
              >
                {title + size}
              </span>
              <DeleteButton onDelete={() => this.deleteTodoList(todoList)} />
            </div>
          );
        })}
      </div>
    );
  }

  @action loadTodoList = todoList => {
    const { note } = this.props;

    note.loadTodoListItems(todoList);
    note.toggleTodoManagePanel();
    // note.toggleTodoLoadModal();
  };

  @action deleteTodoList = todoList => {
    const { note } = this.props;

    note.deleteTodoList(todoList);
    note.toggleTodoManagePanel();
    // note.toggleTodoLoadModal();
  };
}

TodosLoadPanel.propTypes = {
  note: PropTypes.object.isRequired
};
